export default __webpack_public_path__ + "static/926-00c0ace9b55bfc883e4f9f1fb3af153a.gif";